<template>
  <v-container>
    <rfl-form @emitForm="submitForm" :presumptiveDataEach="referPresumptiveDataEach"></rfl-form>
  </v-container>
</template>

<script>
import RflForm from "@/components/presumptive/referral/RflForm.vue";
import {  mapGetters } from "vuex";
export default {
  mounted() {
    this.$store.dispatch("PresumptiveRefer/getEach", this.$route.params.id);
  },
  computed: {
    ...mapGetters("PresumptiveRefer", ["referPresumptiveDataEach"])
  },
  methods: {
    submitForm(data) {
      data.township_id = this.$route.params.township_id;
      this.$store.dispatch("PresumptiveRefer/edit", data);
    }
  },
  components: {
    "rfl-form": RflForm
  }
};
</script>

<style>
</style>